import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-20 px-6 bg-sage/10" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-lg border-2 border-sage/20 text-center relative overflow-hidden" data-id="element-67">
          <div className="absolute top-0 left-0 w-full h-2 bg-sage" data-id="element-68"></div>

          <div className="flex justify-center mb-6" data-id="element-69">
            <div className="bg-sage/10 p-4 rounded-full" data-id="element-70">
              <ShieldCheck className="w-12 h-12 text-sage" data-id="element-71" />
            </div>
          </div>

          <h2 className="text-2xl md:text-4xl font-bold mb-6 font-serif" data-id="element-72">
            Garantía de "Piel de Seda" de 7 Días
          </h2>

          <p className="text-lg md:text-xl text-charcoal/80 leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-73">
            Si en una semana no sientes tu piel más suave o si sientes que la
            información no es para ti, te devolvemos el 100% de tu dinero. Sin
            preguntas.
          </p>

          <p className="text-xl font-bold text-charcoal italic" data-id="element-74">
            "El riesgo es mío, la piel nueva es tuya."
          </p>
        </motion.div>
      </div>
    </section>;
}